import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const ChatComposerPanel = styled(Box)(({ theme }) => ({
  width: '100%',
  backgroundColor: theme.palette.grey[50],
}));
